/** An API failure carrying the server's message, plus its `code` when it sent one. */
export class BotApiError extends Error {
  constructor(message: string, readonly status: number, readonly code: string | null = null) {
    super(message);
    this.name = 'BotApiError';
  }
}

/** Throws the server's message as a BotApiError. */
export async function throwApiError(res: Response): Promise<never> {
  let message = `HTTP ${res.status}`;
  let code: string | null = null;
  try {
    const data = await res.json();
    message = (data && (data.error || data.message)) || message;
    if (data && typeof data.code === 'string') code = data.code;
  } catch { /* keep the status line */ }
  throw new BotApiError(message, res.status, code);
}
